import { Injectable } from '@angular/core';
import { CalendarEventTitleFormatter } from 'angular-calendar';

/**
 * Blocos de sessão SEM tooltip.
 *
 * O angular-calendar mostra um tooltip com o título ao passar o mouse sobre o
 * bloco. Não há input para desligá-lo nas views; o caminho previsto pela lib é
 * devolver valor "falsey" nos métodos `*Tooltip` do formatador de títulos —
 * a diretiva de tooltip não abre nada quando o conteúdo é vazio.
 *
 * Os métodos de TÍTULO (`week`, `day`, `month`) não são sobrescritos: o texto
 * dentro do bloco continua vindo do comportamento padrão.
 */
@Injectable()
export class JemsCalendarEventTitleFormatter extends CalendarEventTitleFormatter {
  weekTooltip(): string {
    return '';
  }

  dayTooltip(): string {
    return '';
  }

  monthTooltip(): string {
    return '';
  }
}
